import { NgModule } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { ValidationService } from './services/validation.service';
import { CustomErrorComponent } from './components/custom-error/custom-error.component';
import { GraphQLModule } from './modules/graphql.module';
import { ConfirmationService } from './services/confirmation.service';
import { CdkAccordion, CdkAccordionItem } from '@angular/cdk/accordion';
import { CdkDropList, CdkDrag } from '@angular/cdk/drag-drop';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { GoogleMapsModule } from '@angular/google-maps';
import { MatDialogActions, MatDialogContent, MatDialogClose, MatDialogModule } from '@angular/material/dialog';
import { MatTooltip } from '@angular/material/tooltip';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgApexchartsModule } from 'ng-apexcharts';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { NgxSkeletonLoaderComponent } from 'ngx-skeleton-loader';
import { SortByNamePipe } from '../app/layout/pages/tickets-setup/pipe/sort-by-name.pipe';
import { CardItemComponent } from '../app/layout/pages/tickets/components/card-item/card-item.component';
import { StatsCardComponent } from '../app/layout/pages/tickets/components/stats-card/stats-card.component';
import { AttachmentComponent } from './components/attachment/attachment.component';
import { AvatarComponent } from './components/avatar/avatar.component';
import { ButtonComponent } from './components/button/button.component';
import { NoteComponent } from './components/note/components/note/note.component';
import { NotesComponent } from './components/notes/notes.component';
import { PaginationComponent } from './components/pagination/pagination.component';
import { SelectAvatarComponent } from './components/select-avatar/select-avatar.component';
import { SelectMultilevelComponent } from './components/select-multilevel/select-multilevel.component';
import { SelectComponent } from './components/select/select.component';
import { ResourceBoardComponent } from './components/resource-board/resource-board.component';
import { SearchComponent } from './components/search/search.component';
import { DescriptionComponent } from './components/description/description.component';
import {MatMenu, MatMenuTrigger} from "@angular/material/menu";
import { CalendarModule } from './components/custom-calendar-control/calendar.module';
import { BkButton } from '@brickclay-org/ui';
import { AssetAssignmentHistoryComponent } from '../app/shared/components/asset-assignment-history/asset-assignment-history.component';
@NgModule({
  declarations: [
    CustomErrorComponent,
    ResourceBoardComponent,  // ✅ Only declared here
    DescriptionComponent,
    AssetAssignmentHistoryComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    BkButton,
    GoogleMapsModule,
    FormsModule,
    NgxSkeletonLoaderComponent,
    NoteComponent,
    ButtonComponent,
    PaginationComponent,
    MatDialogActions,
    MatDialogContent,
    MatDialogClose,
    NgOptimizedImage,
    SelectComponent,
    SelectAvatarComponent,
    SelectMultilevelComponent,
    NgSelectModule,
    NotesComponent,
    AttachmentComponent,
    NgxDaterangepickerMd,
    CdkAccordion,
    CdkAccordionItem,
    CdkDropList,
    CdkDrag,
    AvatarComponent,
    MatTooltip,
    NgApexchartsModule,
    CardItemComponent,
    StatsCardComponent,
    MatDialogModule,
    SortByNamePipe,
    SearchComponent,
    MatMenuTrigger,
    MatMenu,
    CalendarModule
  ],
  exports: [
    CustomErrorComponent,  // ✅ Exported so other modules can use it
    GraphQLModule,
    ResourceBoardComponent,
    DescriptionComponent,
    AssetAssignmentHistoryComponent
  ],
  providers: [
    ValidationService,
    ConfirmationService
  ]
})
export class SharedModule {}
